import { render, staticRenderFns } from "./PPublicStatusModal.vue?vue&type=template&id=7db95fb6&scoped=true&"
import script from "./PPublicStatusModal.vue?vue&type=script&lang=ts&"
export * from "./PPublicStatusModal.vue?vue&type=script&lang=ts&"
import style0 from "./PPublicStatusModal.vue?vue&type=style&index=0&id=7db95fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db95fb6",
  null
  
)

export default component.exports